import { Tabs, TabsProps } from "antd";
import ReservationsAndClients from "../../components/settings/TabsTeamMember/ReservationsAndClients";
import Services from "../../components/settings/TabsTeamMember/Services";
import Sales from "../../components/settings/TabsTeamMember/Sales";
import WorkTeam from "../../components/settings/TabsTeamMember/WorkTeam";
import InventorySpecific from "../../components/settings/TabsTeamMember/InventorySpecific";
import Other from "../../components/settings/TabsTeamMember/Other";
import { FormattedMessage, useIntl } from "react-intl";

type Props = {};

const TeamMemberPermissions = (props: Props) => {
  const intl = useIntl(); // Hook to access the internationalization utility

  const items = [
    {
      key: "1",
      label: intl.formatMessage({ id: "reservationsAndClients" }),
      children: <ReservationsAndClients />,
    },
    {
      key: "2",
      label: intl.formatMessage({ id: "services" }),
      children: <Services />,
    },
    {
      key: "3",
      label: intl.formatMessage({ id: "sales" }),
      children: <Sales />,
    },
    {
      key: "4",
      label: intl.formatMessage({ id: "workTeam" }),
      children: <WorkTeam />,
    },
    {
      key: "5",
      label: intl.formatMessage({ id: "inventorySpecific" }),
      children: <InventorySpecific />,
    },
    {
      key: "6",
      label: intl.formatMessage({ id: "other" }),
      children: <Other />,
    },
  ];
  const onChange = (key: string) => {
    console.log(key);
  };
  return (
    <div>
      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        <span className="">
          <FormattedMessage id="teamPermissionLevelsTitle" />
        </span>
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        <FormattedMessage id="teamPermissionLevelsDescription" />
      </div>
      <div className="permissions">
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </div>
  );
};

export default TeamMemberPermissions;
